import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=dc91b04c&scoped=true"
import script from "./SidebarContent.vue?vue&type=script&lang=js"
export * from "./SidebarContent.vue?vue&type=script&lang=js"
import style0 from "./SidebarContent.vue?vue&type=style&index=0&id=dc91b04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc91b04c",
  null
  
)

export default component.exports